import { EventScheduleDay } from '@shared/components/EventWorkspace/widgets/EventSchedule/components/EventScheduleDay';
import { ScheduleDayProps } from './ScheduleDisplay';
import React from 'react';

export const ModernScheduleDay = (props: ScheduleDayProps) => {
  return <EventScheduleDay day={props.data} />;
};
